<template>
    <v-col
      cols="12"
      md="8"
    >
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "Col8"
}
</script>

<style scoped>

</style>